import { freeze } from '@reduxjs/toolkit';
import { QueryType } from '../apollo/graphqlSchema';

export const ANALYTICS_PAGE_NAMES = freeze<Record<QueryType, string>>({
  [QueryType.Expression]: 'query',
  [QueryType.Funnel]: 'funnel',
  [QueryType.Path]: 'path',
  [QueryType.DataTable]: 'data table',
  [QueryType.Prediction]: 'prediction',
  [QueryType.Retention]: 'retention',
  [QueryType.Significance]: 'significance',
  [QueryType.CohortSample]: 'cohort',
});
